module.exports = __webpack_public_path__ + "assets/img/get_btn.00a54d18.png";